/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled               from 'styled-components';
import { Spacing, Colours } from '../../../styles/variables';
import { Media }            from '../../../styles/utilities';

/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledResponsiveFlexContent = styled.div`
  flex: 1;
  padding: ${Spacing.Small} 0;
  border-top: 1px solid ${Colours.Alto};
  &:first-child {
    border: 0;
    padding-top: 0;
  }
  &:last-child {
    padding-bottom: 0;
  }
  ${Media.Tablet`
    padding: 0 ${Spacing.Small};
    border-top: 0;
    border-left: 1px solid ${Colours.Alto};
    &:first-child {
      border-left: 0;
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
  `}
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledResponsiveFlexContent/index.js